// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonButton,
  IonFooter,
  IonGrid,
  IonRow,
  IonText,
  IonToolbar
} from "@ionic/react"
import { useLocales } from "react-localized"
import { useHistory } from "react-router"
import { ScreenSizeConditional, SectionContainer } from "../lib"
import ProcurementSectionMenu from "./ProcurementSectionMenu"
import {PurchaseOrder} from "../models"
import { ResponsiveIonCol } from "../components/ResponsiveIonCol"


const PurchaseOrderPlaced: React.FC<{order: PurchaseOrder}> = ({order}) => {
  const {gettext} = useLocales()
  const history = useHistory()
  const onClick: () => void = () => {
    PurchaseOrder.clear()
    history.push("/procurement/orders")
  }
  return (
    <>
      <SectionContainer
        canGoBack={false}
        menuComponent={ProcurementSectionMenu}
        ready={true}
        title={gettext("Purchase order placed")}
      >
        <IonGrid style={{paddingTop: "var(--section-padding)"}}>
          <IonRow className="panel">
            <ResponsiveIonCol>
              <IonText>
                {gettext("The purchase order was sent to the supplier.")}
              </IonText>
              <IonButton
                color="primary"
                className="px-0"
                fill="clear"
                onClick={onClick}
                style={{marginTop: "22px"}}
              >
                {gettext("Back to purchase orders")}
              </IonButton>
            </ResponsiveIonCol>
          </IonRow>
        </IonGrid>
      </SectionContainer>
      <ScreenSizeConditional>
        <IonFooter>
          <IonToolbar>
            <IonButton
              color="primary"
              fill="clear"
              onClick={onClick}
              style={{width: "100%"}}
            >
              {gettext("Back to purchase orders")}
            </IonButton>
          </IonToolbar>
        </IonFooter>
      </ScreenSizeConditional>
    </>
  )
}

export default PurchaseOrderPlaced